<div class="d-lg-block d-none">
  <fgb-banner [title]="'challenges.text' | translate"></fgb-banner>
</div>

<div class="widget-mobile">
  <div class="pt-lg-4 pb-lg-4 pt-2 pb-0 container">
    <fgbcl-badge-achieved></fgbcl-badge-achieved>
  </div>

  <!--Scorecard carousel-->
  <div class="mt-4">
    <fgbcl-scorecard-list-view
      [isSponsorInBody]="false"
      [icon]="'chevron_right'"
      [showPlaceholder]="true"
    ></fgbcl-scorecard-list-view>
  </div>
</div>
